<template>
  <div>
    <PageAllow controller="StockPositionLabels" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="4" sm="12" md="4">
            <v-text-field
              ref="label_name"
              v-model="searchFields"
              @text="searchFields = $event"
              :label="$t('PositionLabel.Fields.label_name')"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center">
              <v-spacer />
              <v-btn
                v-if="$permission.permissionAllow('StockPositionLabels', 'add')"
                small
                color="primary"
                @click.stop="
                  currentItem = { status: 1, allow_picking: 1 };
                  editDialog = true;
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("PositionLabel.ObjectName")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <div class="mx-4 my-4">
          <v-data-table
            :headers="headers"
            :items="stockPositionLabels"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            :search="searchFields"
            multi-sort
            class="elevation-2 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.allow_picking="{ item }">
              <v-chip
                small
                label
                :color="item.allow_picking | positionLabelPickingFlgsColor"
                :text-color="
                  item.allow_picking | positionLabelPickingFlgsTextColor
                "
              >
                {{ item.allow_picking | positionLabelPickingFlgsText }}
              </v-chip>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                label
                :color="item.status | positionLabelStatusColor"
                :text-color="item.status | positionLabelStatusTextColor"
              >
                {{ item.status | positionLabelStatusText }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip
                top
                v-if="
                  $permission.permissionAllow('StockPositionLabels', 'edit')
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      editDialog = true;
                      currentItem = JSON.parse(JSON.stringify(item));
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{ $t("CRUD.editInfo", [$t("Position.title")]) }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="
                  $permission.permissionAllow(
                    'StockPositionLabels',
                    'delete'
                  ) && Number(item.deletable)
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="accent"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItem = JSON.parse(JSON.stringify(item));
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>{{ $t("CRUD.deleteInfo", [$t("Position.title")]) }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <!-- 编辑弹窗 -->
    <v-dialog persistent v-model="editDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("PositionLabel.ObjectNameInfo") }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("PositionLabel.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('PositionLabel.Fields.label_name')"
                      rules="required"
                    >
                      <v-text-field
                        required
                        v-model="currentItem.label_name"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'number')
                            .concat(errors)
                        "
                      >
                        <template v-slot:label>
                          {{ $t("PositionLabel.Fields.label_name") }}
                          <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <v-radio-group
                      row
                      v-model="currentItem.allow_picking"
                      :label="
                        $t('PositionLabel.Fields.isPicking') +
                        $t('Global.colon')
                      "
                    >
                      <v-radio
                        v-for="picking_flgs in $consts.positionLabel
                          .picking_flgs"
                        :key="picking_flgs.value"
                        :label="`${picking_flgs.text}`"
                        :value="picking_flgs.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12">
                    <v-radio-group
                      row
                      v-model="currentItem.status"
                      :label="
                        $t('PositionLabel.Fields.status') + $t('Global.colon')
                      "
                    >
                      <v-radio
                        v-for="status in $consts.positionLabel.status"
                        :key="status.value"
                        :label="`${status.text}`"
                        :value="status.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="editDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="saveEdit()">{{
            $t("CRUD.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('Position.ObjectName')"
      @confirm="
        del();
        deleteDialog = false;
      "
    />
  </div>
</template>
<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import { mapState } from "vuex";
import StockPositionLabels from "@/api/stock_position_labels";
import Stocks from "@/api/stocks";
import DialogDelete from "@/components/plugins/DialogDelete";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    DialogDelete,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stocks"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.positionLabel"),
          disabled: true,
          href: "/stocks/position-labels" + "?stock_id=" + this.stock_id,
        },
        {
          text: this.stock && this.stock.name ? this.stock.name : "",
          disabled: false,
          accent: true,
        },
      ];
    },
    headers: () => [
      {
        text: i18n.t("PositionLabel.Fields.label_name"),
        align: "start",
        sortable: false,
        value: "label_name",
      },
      {
        text: i18n.t("PositionLabel.Fields.isPicking"),
        align: "start",
        sortable: false,
        value: "allow_picking",
      },
      {
        text: i18n.t("PositionLabel.Fields.status"),
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    stock_id: 0,
    stock: {},
    searchFields: "",
    stockPositionLabels: [],
    paging: {},
    editDialog: false,
    currentItem: {},
    currentPositionLabel: null,
    serverErrors: [],
    deleteDialog: false,
  }),

  mounted() {
    if (this.$route.query.stock_id) {
      this.stock_id = this.$route.query.stock_id;
      //获取仓库信息
      Stocks.fetchOne(this.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
          }
        }.bind(this)
      );
    }
    this.getStockPositionLabelsFromAPI();
  },

  methods: {
    getStockPositionLabelsFromAPI() {
      StockPositionLabels.fetch({ stock_id: this.stock_id }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockPositionLabels = response.data.stock_position_labels;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    saveEdit() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = [];
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            this.currentItem.stock_id = this.stock_id;
            StockPositionLabels.save(this.currentItem.id, this.currentItem)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.currentItem);
                    this.getStockPositionLabelsFromAPI();
                    this.editDialog = false;
                    this.$store.dispatch("fullscreenLoadingStop");
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                    this.$store.dispatch("fullscreenLoadingStop");
                  }
                }.bind(this)
              )
              .catch(
                function () {
                  this.editDialog = false;
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    del() {
      StockPositionLabels.del(this.currentItem.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getStockPositionLabelsFromAPI();
          }
        }.bind(this)
      );
    },
  },
};
</script>